import { useState, useRef, useEffect } from "react";
import { ref, uploadBytes, deleteObject } from 'firebase/storage';
import { collection, doc, addDoc, setDoc, deleteDoc } from 'firebase/firestore';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import noPicture from './images/no_picture.jpg';
import Select from 'react-select';

const EditRecommend = (props) => {
    
    const pickerFilter = ['.jpg','.png','.jpeg'];
    const picturePicker = useRef(null);
    

    const [title, setTitle] = useState(props.new?'':props.recommend.title);
    const [legend, setLegend] = useState(props.new?'':props.recommend.legend);
    const [restaurant, setRestaurant] = useState(props.new?'':{label: '',value: props.recommend.target});
    const [background, setBackground] = useState(props.new ? noPicture:props.picture);
    const [newPicture, setNewPicture] = useState();
    const [saving, setSaving] = useState(false);

    const autoId = () => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let autoId = '';
        for (let i = 0; i < 20; i++) {
            autoId += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return autoId;
    }

    const handlePictureChange = (e) => {
        let file = e.target.files[0];

        var reader = new FileReader();

        // Callback for read complete
        reader.onload = function(e) {
            setNewPicture(e.target.result);
        };

        // Callback for read error
        reader.onerror = function(e) {
            console.log("Error loading picture: ",e);
        };
        
        reader.readAsDataURL(file);
    }

    useEffect(() => {
        let i = props.restaurantList.findIndex((res) => {
            if(res.id == restaurant.value){
                setRestaurant({ label: res.name, value: res.id});
                return true;
            }
            return false;
        });

        if(i == -1) setRestaurant("");
        
    },[props.recommend])

    const save = async () => {
        let updatePack = {
            isBlank: false,
            title: title,
            legend: legend,
            target: restaurant.value,
            picture: props.new? 'no_picture.jpg':props.recommend.picture
        };

        if(props.new){
            if(!newPicture){
                window.alert("Debes colocar una foto");
                setSaving(false);
                return;
            }else if(title.trim() === ""){
                window.alert("Debes colocar un titulo");
                setSaving(false);
                return;
            }else if(legend.trim() === ""){
                window.alert("Debes colocar una legenda valida.");
                setSaving(false);
                return;
            }else if(!restaurant.value){
                window.alert("Elige un restaurante valido.");
                setSaving(false);
                return;
            }else{
                let picture = Date.now().toString();
                const newID = autoId();

                await uploadPicture(newPicture, picture, newID);

                const resRef = doc(props.eDB, `Recommendations/${newID}`);
                setDoc(resRef, {...updatePack, picture: picture}, { merge: true});

                setSaving(false);
                props.close();
            }
        }else if(props.delete){
            const pictureRef = ref(props.storage, `Recommendations/${props.id}/${props.recommend.picture}`);
            deleteObject(pictureRef).catch((error) => {
                console.log("Error deleting, doesn't exists?");
            });

            console.log("Eliminando: ", props.id);

            const dishRef = doc(props.eDB, `Recommendations/${props.id}`);
            await deleteDoc(dishRef);

            setSaving(false);
            props.close();
        }else{
            if(title.trim() === ""){
                window.alert("Debes colocar un titulo");
                setSaving(false);
                return;
            }else if(legend.trim() === ""){
                window.alert("Debes colocar una legenda valida.");
                setSaving(false);
                return;
            }else if(!restaurant.value){
                window.alert("Elige un restaurante valido.");
                setSaving(false);
                return;
            }else{
                if(newPicture){
                    updatePack.picture = Date.now().toString();
    
                    //Update in current list
                    props.setPicture(newPicture);
                    
                    //Upload new Picture
                    await uploadPicture(newPicture, updatePack.picture, props.id);
    
                    // Delete current Picture
                    const pictureRef = ref(props.storage, `Recommendations/${props.id}/${props.recommend.picture}`);
                    deleteObject(pictureRef).catch((error) => {
                        console.log("Error deleting, doesn't exists?");
                    });
                }
    
                //Update doc values
    
                if(compareRec(props.recommend, updatePack)){
                    const resRef = doc(props.eDB, `Recommendations/${props.id}`);
                    setDoc(resRef, updatePack, { merge: true});
                }
    
                setSaving(false);
                props.close();
            }
        }
    }

    const compareRec = (originalRec, newRec) => {
        if(originalRec.title !== newRec.title) return true;
        if(originalRec.legend !== newRec.legend) return true;
        if(originalRec.picture !== newRec.picture) return true;
        if(originalRec.target !== newRec.target) return true;
        return false;
    }

    const uploadPicture = async (picture, name, id) => {
        const stoRef = ref(props.storage, `Recommendations/${id}/${name}`);
        const blobFrom = await fetch(picture);
        const result = await blobFrom.blob();
        await uploadBytes(stoRef, result);
    }
    
    return (
        <>
        <div style={{position: 'relative', maxWidth: '350px'}}>
            <div className="Recommend" style={{minHeight: '450px', height: '450px'}}>
                <div style={{overflow: 'hidden', textAlign: 'center', maxHeight: '450px'}} >
                    <img src={newPicture?newPicture:background} width='100%'/>
                </div>

                <div className='RecommendGradientPreview'></div>

                <div style={{display: props.preview ? 'none':'flex'}} className='EditTools'>
                    <button style={{display: newPicture ? 'none':'block'}} onClick={() => picturePicker.current.click()} className="cbtn" disabled={props.delete}><MdModeEditOutline size='1rem' pointerEvents='none'/></button>
                    <button style={{display: newPicture ? 'block':'none'}} onClick={() => {picturePicker.current.value = ''; setNewPicture(undefined);}} className="cbtn"><MdDelete size='1rem' pointerEvents='none'/></button>
                    <input className='d-none' type='file' accept={pickerFilter} ref={picturePicker} onChange={handlePictureChange} />
                </div>

                <div className="Info">
                    <div className="d-flex d-col-dir m-auto">
                        <input type='text' value={title} onChange={(e) => setTitle(e.target.value)} className="tx-center m-auto tx-black" disabled={props.delete}/>
                        <input type='text' value={legend} onChange={(e) => setLegend(e.target.value)} className="Legend m-auto tx-red" disabled={props.delete}/>
                    </div>
                </div>
            </div>

            <div className="selectSearch">
                <Select
                    placeholder='Elegir restaurante'
                    value={restaurant}
                    onChange={(selected) => setRestaurant(selected)}
                    options={
                        props.restaurantList.map((res) => {
                            return { value: res.id, label: res.name };
                        })
                    }
                    isDisabled={props.delete}
                />
            </div>
            
            <div className="mt-2">
                <button className={props.delete? 'm-auto btn btn-cancel':'m-auto btn btn-accept'} onClick={() => {setSaving(true);save();}} disabled={saving}>{saving?<progress></progress>:(props.delete?'Borrar':'Guardar')}</button>
            </div>
        </div>
        </>
    );
}

export default EditRecommend;